"use client";
import { Button, Form, Input } from "antd";
import { useTranslation } from "@/app/i18n/client";
import useFetch from "@/hooks/useFetch";
import ContactUsActions from "@/actions/contact-us";
import useSession from "@/hooks/useSession";
const { TextArea } = Input;
const ContactForm = ({ lng }) => {
  const contactUsActions = ContactUsActions();
  const { user } = useSession();

  const defaultValues = {
    senderPhone: user?.phone,
    senderName: user?.name,
    senderEmail: user?.email,
  };

  const { fetchData, loading } = useFetch();
  const { t } = useTranslation(lng, "common");

  const [form] = Form.useForm();

  const onSubmit = async (values) => {
    const response = await fetchData(() =>
      contactUsActions.sendMessage(values)
    );
    if (!response) return;
    form.resetFields();
  };

  return (
    <Form
      form={form}
      onFinish={onSubmit}
      layout="vertical"
      initialValues={defaultValues}
      className="w-full mx-auto flex flex-col justify-center items-center  "
    >
      <Form.Item
        name="senderName"
        className="w-full"
        rules={[{ required: true, message: t("common:name-required") }]}
      >
        <Input
          placeholder={t("common:label-name-required")}
          className="bg-transparent !border-primary rounded-full py-3"
          disabled={loading}
        />
      </Form.Item>
      <Form.Item
        name="senderPhone"
        className="w-full"
        rules={[
          { required: true, message: t("common:phone-required") },
          {
            pattern: /^[0-9]{10}$/,
            message: t("common:phone-error"),
          },
        ]}
      >
        <Input
          // type="tel"
          className="bg-transparent !border-primary rounded-full py-3"
          placeholder={t("common:label-phone-required")}
          disabled={loading}
        />
      </Form.Item>
      <Form.Item
        name="senderEmail"
        className="w-full"
        rules={[
          { required: true, message: t("common:label-email-required") },
          {
            pattern:
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: t("common:email-error"),
          },
        ]}
      >
        <Input
          type="email"
          className="bg-transparent border-primary rounded-full py-3"
          placeholder={t("common:label-email-required")}
          disabled={loading}
        />
      </Form.Item>
      <Form.Item name="messageContent" className="w-full">
        <TextArea
          color="primary"
          placeholder={t("common:label-message")}
          className="bg-transparent border-primary rounded-xl py-3"
          disabled={loading}
          style={{ height: 150, resize: "none" }}
        />
      </Form.Item>
      <Form.Item className="w-full flex  justify-center">
        <Button
          type="primary"
          loading={loading}
          htmlType="submit"
          className="py-4 rounded-full !bg-primaryDark "
          style={{ width: "200px" }}
        >
          <span className="text-bgLight text-lg">
            {t("common:button-send-message")}
          </span>
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ContactForm;
